import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'Отсутствует альтернативный текст для этого изображения',
    noAnswers: 'Нет варианта ответа, нажмите на «Далее», чтобы продолжить.',
    placeholder: 'Введите Ваш ответ...',
    pleaseSelect: 'Выберите вариант...',
    rotateLandscape: 'Отключите блокировку ориентации на телефоне и поверните его в альбомную ориентацию.',
    rotatePortrait: 'Поверните телефон с ландшафтной ориентации на портретную.',
    ir: {
      selectWebCam: 'Выберите веб-камеру (если доступна) или нажмите на «Обзор» для загрузки с вашего устройства',
      noWebCam: 'Веб-камера не обнаружена',
      accessCamUpload: 'ДОСТУП К КАМЕРЕ/ЗАГРУЗИТЬ',
      browse: 'ОБЗОР',
      uploadPhoto: 'Загрузить фото',
      instead: 'вместо',
      startOver: 'НАЧАТЬ ЗАНОВО',
      capture: 'СНИМОК',
      allDone: 'ВСЕ ГОТОВО!',
      somethingWrong: 'Извините, что-то пошло не так. Повторите попытку позже',
      couldntRead: 'К сожалению, мы не смогли считать код!',
      couldntProcess: 'К сожалению, мы не смогли обработать ваше изображение!',
      moveOn: 'Попробуйте еще раз или отправьте фото и двигайтесь дальше',
      tryAgain: 'Повторите попытку',
      dataReceived: 'Данные получены!',
      enterManually: 'Повторите попытку или введите данные вручную ниже',
      positionQR:
        'Расположите QR-код перед камерой, вписав его в красную рамку, или загрузите его с вашего компьютера.',
      submit: 'ОТПРАВИТЬ',
      analyzing: 'Выполняется анализ изображения, подождите...',
      cantAnalyze:
        'Внимание! Не удалось отобразить это изображение. Повторите попытку или выберите более распространенный формат изображения (JPG, PNG, GIF, BMP).',
      wrongFormat:
        'К сожалению, мы не поддерживаем этот формат файла. Загрузите поддерживаемый тип изображения (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    vr: {
      noWebCam: 'Веб-камера не обнаружена',
      uploadVideo: 'Загрузить видео',
      skip: 'Пропустить?',
      accessCamUpload: 'ДОСТУП К КАМЕРЕ/ЗАГРУЗИТЬ',
      browse: 'ОБЗОР',
      instead: 'Вместо',
      or: 'или',
      stopRecording: 'Остановить запись',
      willBeStopped: 'Запись остановится по истечении 5 минут',
      stopOnDone: 'Остановите запись, когда закончите!',
      record: 'ЗАПИСЬ',
      somethingWrong: 'Извините, что-то пошло не так. Повторите попытку позже',
      microphone: 'Микрофон',
      camera: 'Веб-камера',
      selectMicrophone: 'Выберите микрофон',
      selectCam: 'Выберите веб-камеру',
      upload: 'Загрузить',
      playback: 'Воспроизведение',
      stopPlayback: 'Остановить',
      submit: 'ОТПРАВИТЬ',
      startOver: 'ЗАНОВО',
      allDone: 'ГОТОВО!',
      alternativeRecordSpan: 'Загрузите видеоклип с Вашего компьютерного устройства.<br/>Как вариант, Вы можете &nbsp;',
      alrenativeRecordHref: ' записать видео с веб-камеры.',
      cantAnalyze:
        'Внимание! Не удалось отобразить это видео. Повторите попытку или выберите более распространенный формат видео (MP4, M4V, WEBPM)',
      wrongFormat:
        'К сожалению, мы не поддерживаем этот формат файла. Загрузите видео в поддерживаемом формате (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)'
    },
    cjc: {
      choose: 'ВЫБРАТЬ',
      pleaseChoose: 'Пожалуйста, выберите',
      this: 'ЭТОТ',
      one: 'один',
      myChoice: 'Мой ВЫБОР'
    },
    hm: {
      addComment: 'Добавьте комментарий ниже',
      commentMandatoryPlaceHolder: 'Добавьте обязательный комментарий...',
      commentOptionalPlaceHolder: 'Добавьте необязательный комментарий... ',
      dragPin: 'Перетащите, чтобы изменить положение (длительное нажатие для точной фиксации).',
      removePin: 'Для удаления перетащите пин за пределы изображения.',
      editComment: 'Нажмите на пин, чтобы изменить комментарий. ',
      addPin: 'Перетащите пин из панели ниже и поместите его в нужное место на изображении.',
      addPins: 'Перетащите пины из панели ниже и поместите их в нужное место на изображении. ',
      leavePins: (minPoints, maxPoints) =>
        `Поставьте не менее ${minPoints}, но не более ${maxPoints} пинов каждого типа.`,
      leavePinsAny: (minPoints, maxPoints) =>
        `Поставьте не менее ${minPoints}, но не более ${maxPoints} пинов любого типа.`,
      leavePinsPerPage: (minPoints, maxPoints) => `Поставьте не менее ${minPoints}, но не более ${maxPoints} пинов.`,
      leavePinsWithOff: maxPoints =>
        `Поставьте не более ${maxPoints} пинов каждого типа или нажмите «Дальше», чтобы пропустить.`,
      leavePinsWithOffAny: maxPoints =>
        `Поставьте не более ${maxPoints} пинов любого типа или нажмите «Дальше», чтобы пропустить.`,
      leavePinsPerPageWithOff: maxPoints =>
        `Поставьте не более ${maxPoints} пинов или нажмите «Дальше», чтобы пропустить.`,
      leavePinWithOff: 'Поставьте не более 1 пина каждого типа или нажмите «Дальше», чтобы пропустить.',
      leavePinWithOffAny: 'Поставьте не более 1 пина любого типа или нажмите «Дальше», чтобы пропустить.',
      leavePinPerPageWithOff: 'Поставьте не более 1 пина или нажмите «Дальше», чтобы пропустить.',
      leaveExactlyPin: 'Поставьте по 1 пину каждого типа.',
      leaveExactlyPinAny: 'Поставьте 1 пин любого типа.',
      leaveExactlyPinPerPage: 'Поставьте 1 пин.',
      leaveExactlyPins: maxPoints =>
        `Поставьте по ${maxPoints} пин${maxPoints >= 2 ? (maxPoints < 5 ? 'а' : 'oв') : ''} каждого вида.`,
      leaveExactlyPinsAny: maxPoints =>
        `Поставьте по ${maxPoints} пин${maxPoints >= 2 ? (maxPoints < 5 ? 'а' : 'oв') : ''} любого вида.`,
      leaveExactlyPinsPerPage: maxPoints =>
        `Поставьте по ${maxPoints} пин${maxPoints >= 2 ? (maxPoints < 5 ? 'а' : 'oв') : ''}.`,
      leaveComment: 'Введите текст под изображением, чтобы оставить комментарий.',
      noAnswers: 'Нет варианта ответа. Для продолжения нажмите «Далее».',
      outOfPins: 'у вас не осталось пинов',
      pinsBehavior: 'При перемещении по изображению вы увидите области, которые будут выделены когда в них стоит пин.',
      clusters: 'Вы можете размещать пины только в этих выделенных областях.',
      contentAware: 'Вы можете помещать пины внутрь выделенных областей или снаружи них.'
    },
    mp: {
      expand_note: 'Пожалуйста, наведите курсор или нажмите на изображение(-я), чтобы развернуть',
      rb_note: rows => `Пожалуйста, выберите только 1 ответ в каждом пункте${rows ? ' ниже' : ''}:`,
      cb_note: (min, max, rows) => {
        if (1 === min && 5000 === max) {
          return 'Выберите все подходящие варианты:'
        } else if (min === max) {
          return `Пожалуйста, выберите любые ${min < 5 ? 'а' : 'ов'} в каждом пункте${rows ? ' ниже' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Выберите минимум ${min}, но не более ${max} ответов в каждом пункте${rows ? ' ниже' : ''}:`
        } else if (5000 === max && min > 0) {
          return `Выберите минимум ${min} ответ${max >= 2 ? (max < 5 ? 'а' : 'ов') : ''} в каждом пункте${
            rows ? ' ниже' : ''
          }:`
        } else if (0 === min && max < 5000) {
          return `Выберите не более ${max} ответ${1 == min ? 'а' : 'ов'} в каждом пункте${rows ? ' ниже' : ''}:`
        } else {
          return 'Выберите все подходящие варианты:'
        }
      }
    },
    sh: {
      note: 'Нажмите на товар, чтобы увеличить его и добавить в свою виртуальную корзину, если бы вы купили его в магазине',
      amazonNote: 'Нажмите на товар, чтобы увеличить его и добавить в свою виртуальную корзину.',
      fullCart: 'Ваша корзина заполнена!',
      qty: 'КОЛ-ВО',
      addToCart: 'ДОБАВИТЬ В КОРЗИНУ',
      deleteFromCart: 'УДАЛИТЬ',
      emptyCard: 'Ваша корзина пуста',
      each: 'каждый',
      items: 'продуктов',
      total: 'Корзина',
      clearCart: 'Очистить корзину',
      backToStore: 'Назад в магазин',
      na: 'Ничего из перечисленного',
      next: 'ДАЛЕЕ',
      maxCartCountError: max => `Добавьте в свою корзину не более ${max} товаров.`,
      scrollError: `Полностью прокрутите страницу влево и вправо, чтобы продолжить прохождение опроса. `,
      maxSpentError: max => `Потратьте не более ${max}.`,
      maxProductCountError: max => `Добавьте в корзину каждого товара не более ${max}.`
    },
    rb: {
      note: 'Выберите 1 вариант:'
    },
    vo: {
      note: 'Досмотрите видео до конца'
    },
    cb: {
      note: (min, max) => {
        if (min === max) {
          return `Выберите ${min} чекбокс${min >= 3 ? (min < 5 ? 'а' : 'ов') : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Выберите от ${min} до ${max} чекбокс${max >= 3 ? (max < 5 ? 'а' : 'ов') : ''}:`
        } else if (5000 === max && min > 0) {
          return `Выберите не менее ${min} чекбокс${min >= 3 ? (min < 5 ? 'а' : 'ов') : ''}:`
        } else if (0 === min && max < 5000) {
          return `Выберите не более ${max} чекбокс${max >= 3 ? (max < 5 ? 'а' : 'ов') : ''}:`
        } else {
          return 'Выберите все подходящие варианты:'
        }
      }
    },
    oe: {
      na: 'Не применимо',
      note: (min, max, optional) => {
        if (min === max) {
          return `Введите ${min} символ${min > 1 && min <= 4 ? 'а' : ''}${min >= 5 ? 'ов' : ''}${
            optional ? ' (необязательное поле)' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Введите от ${min} до ${max} символ${min > 1 && min <= 4 ? 'а' : ''}${min >= 5 ? 'ов' : ''}${
            optional ? ' (необязательное поле)' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Введите не менее ${min} символ${min > 1 && min <= 4 ? 'а' : ''}${min >= 5 ? 'ов' : ''}${
            optional ? ' (необязательное поле)' : ''
          }:`
        } else if (0 === min && max < 5000) {
          return `Введите не более ${min} символ${min > 1 && min <= 4 ? 'а' : ''}${min >= 5 ? 'ов' : ''}${
            optional ? ' (необязательное поле)' : ''
          }:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'Заполните следующие поля:'
    },
    mx: {
      note: 'Переместите выделенные слайдеры, чтобы продолжить',
      dragSlider: 'Передвиньте слайдер влево или вправо'
    },
    psc: {
      dragLeftRight: 'Передвиньте слайдер влево или вправо'
    },
    ps: {
      note: value => `Пожалуйста, распределите оставшиеся ${value} между приведенными ниже строками`,
      allDone: 'ВСЕ ГОТОВО!',
      total: `Всего:`,
      dragSlider: 'Передвиньте слайдер влево или вправо'
    },
    cx: {
      note: 'Кликните по комбобоксу и начните печатать Ваш ответ или выберите его из списка'
    },
    ro: {
      note: 'Отсортируйте варианты путем перетаскивания вверх или вниз:'
    },
    md: {
      note1: 'Пожалуйста, кликните и выберите лучший вариант.<br/>Повторное нажатие отменяет выбор.',
      note2: 'Пожалуйста, кликните и выберите худший вариант.<br/>Повторное нажатие отменяет выбор.',
      note3: 'Спасибо! Нажмите далее, чтобы продолжить<br/>или нажмите неотмеченный вариант, чтобы начать заново.'
    },
    aro: {
      note: 'Пожалуйста, выберете один вариант из каждой пары:'
    },
    wd: {
      note: 'Пожалуйста, убедитесь, что каждое следующее значение больше предыдущего.'
    },
    emd: {
      note: 'Досмотрите видео до конца',
      noAnswers: 'Нет варианта ответа, нажмите на «Далее», чтобы продолжить.',
      start: 'Нажмите и удерживайте, чтобы начать',
      resume: 'Нажмите и удерживайте, чтобы возобновить',
      continue: 'Вы закончили! <br />Нажмите <strong>«Далее»</strong>, чтобы продолжить',
      continueMobile: 'Вы закончили! <br />Нажмите здесь, чтобы продолжить',
      training: {
        session: 'сеанс обучения',
        note: 'Закончите обучение',
        moveLeft: 'Перетащите указатель до упора влево',
        moveBottom: 'Перетащите указатель до упора вниз',
        moveRight: 'Перетащите указатель до упора вправо',
        moveTop: 'Перетащите указатель до упора вверх',
        success: 'Отличная работа!'
      }
    },
    sft: {
      noAnswers: 'Нет варианта ответа, нажмите на «Далее», чтобы продолжить.',
      note: 'Как можно быстрее выберите ответ, который интуитивно кажется правильным',
      finish: 'Все готово! <br /> Нажмите «Далее», чтобы продолжить',
      training: {
        start:
          '<p>В этом вопросе вам быстро покажут разные слова и вам нужно будет сосредоточиться. ' +
          'Вам нужно будет быстро отреагировать, чтобы ответить. </p> <p>Готовы потренироваться?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `Нажмите "{buttonLeft}"`
            : (mouse ? `Нажмите "{buttonLeft}"` : '') + (key && mouse ? ' / ' : '') + (key ? `Нажмите клавишу F` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `Нажмите "{buttonRight}"`
            : (mouse ? `Нажмите "{buttonRight}"` : '') + (key && mouse ? ' / ' : '') + (key ? `Нажмите клавишу J` : ''),
        fail: () => 'Слишком медленно',
        success: () => 'Отлично!',
        finish: () =>
          '<p><strong> Великолепно!</strong></p><p>Убедитесь, что ничто не будет отвлекать вас <br />' +
          'в следующие 2–3 минуты. </p><p>Нажмите «Далее», чтобы начать, когда будете готовы.</p>'
      },
      buttons: {
        start: 'Начать',
        yesno: {
          left: 'Да',
          right: 'Нет'
        },
        matches: {
          left: 'Совпадение',
          right: 'Несовпадение'
        },
        fits: {
          left: 'Подходит',
          right: 'Не подходит'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
